import { ref, computed } from 'vue'
import store from '../store'


const permissions = computed(() => store.getters['permission/permissions'])

// Rôle par boutique : sur les écrans d'une boutique où l'utilisateur a un rôle propre (et en
// caisse), les permissions de ce rôle s'ajoutent à celles de son rôle général.
function permissionsFor(shopId) {
    const id = shopId === 'active'
        ? (store.getters['user/currentShop']?.id ?? store.getters['user/currentUser']?.shop_id)
        : shopId
    const own = id ? store.getters['permission/shopPermissions']?.[id] : null

    return Array.isArray(own) ? permissions.value.concat(own) : permissions.value
}

function hasAbility(list, permissionName = null) {
    let access = false
    if(permissionName){
        if(list.length){
            if(Array.isArray(permissionName)){
                if(permissionName.length === 0){
                    access = true
                }
                for(let perm of permissionName){
                    if(!access){
                        access = list.indexOf(perm) !== -1
                    }
                }
            }else {
                access = list.indexOf(permissionName) !== -1
            }
        }
    }else{
        access = true
    }

    return access
}

export function useHasAbility() {
    // selon l'écran courant : boutique affichée, boutique active en caisse, sinon rôle général
    function can(permissionName = null){
        return hasAbility(permissionsFor(store.getters['permission/contextShopId']), permissionName)
    }

    // dans la boutique où l'utilisateur travaille, quel que soit l'écran (ex. bouton « Caisse »)
    function canInActiveShop(permissionName = null){
        return hasAbility(permissionsFor('active'), permissionName)
    }

    return { can, canInActiveShop }
  }
